/**
 * StepPlaceholderCard
 * Placeholder card for upcoming steps that are not yet implemented
 */

import React from 'react';
import { Lock } from 'lucide-react';

export default function StepPlaceholderCard({ stepNumber, title, description, isLocked = true }) {
  return (
    <div 
      className={`border rounded-xl p-6 ${
        isLocked 
          ? 'bg-muted/30 border-muted opacity-60' 
          : 'bg-surface border-border'
      }`}
      data-testid={`step${stepNumber}-placeholder`}
    >
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
          isLocked ? 'bg-muted' : 'bg-primary/10'
        }`}>
          {isLocked ? (
            <Lock className="w-5 h-5 text-muted-foreground" />
          ) : (
            <span className="text-lg font-semibold text-primary">{stepNumber}</span>
          )}
        </div>
        <div>
          <h3 className={`font-semibold ${isLocked ? 'text-muted-foreground' : 'text-foreground'}`}>
            {title}
          </h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
    </div>
  );
}
